import React from "react"

import OtherOffers from "../OtherOffers"

import type { OtherOffersProps } from "../OtherOffers"

export const NewSeoOtherOffers = ({
  tags,
  title,
  breakpointColumnsObj,
  orderNum,
  variant,
  pageUrl,
}: OtherOffersProps) => (
  <section data-exclude={orderNum}>
    <OtherOffers
      variant={variant}
      title={title}
      tags={tags}
      breakpointColumnsObj={breakpointColumnsObj}
      pageUrl={pageUrl}
    />
  </section>
)
